var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyfintoo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55151 6.78552V9.03552H15.0515V6.78552C15.0515 4.71365 13.3734 3.03552 11.3015 3.03552C9.22964 3.03552 7.55151 4.71365 7.55151 6.78552ZM4.55151 9.03552V6.78552C4.55151 3.05896 7.57495 0.0355225 11.3015 0.0355225C15.0281 0.0355225 18.0515 3.05896 18.0515 6.78552V9.03552H18.8015C20.4562 9.03552 21.8015 10.3808 21.8015 12.0355V21.0355C21.8015 22.6902 20.4562 24.0355 18.8015 24.0355H3.80151C2.14683 24.0355 0.801514 22.6902 0.801514 21.0355V12.0355C0.801514 10.3808 2.14683 9.03552 3.80151 9.03552H4.55151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyfintoo3);
export default __webpack_public_path__ + "static/media/whyfintoo3.d2b5669b5a4f578dc08106ab3020d258.svg";
export { ForwardRef as ReactComponent };